import { site, fullAddress } from "@/config/site";
import { SEO } from "@/components/site/SEO";
import { Reveal } from "@/components/site/Reveal";

const sections = [
  {
    title: "Who we are",
    body: `${site.legalName} ("we", "us") is a made-to-measure blinds and shutters specialist based at ${fullAddress}. You can contact us at ${site.email} or on ${site.phone.display}. We are the data controller for personal information collected through this website.`,
  },
  {
    title: "What we collect",
    body: "When you request a design visit, quote or callback, or send us a message, we collect the details you provide: your name, contact details (phone and email), postcode, the products and rooms you're interested in, preferred appointment times and anything you choose to add. We also record the page you enquired from and, where present, campaign (UTM) parameters, so we know how you found us.",
  },
  {
    title: "How we use it",
    body: "We use your information to respond to your enquiry, arrange and carry out home visits, prepare quotations, and fulfil orders. We only send marketing messages (offers and news) where you have separately opted in, and you can withdraw that consent at any time by contacting us.",
  },
  {
    title: "Lawful basis",
    body: "We process enquiry details because it is necessary to take steps at your request before entering a contract, and for our legitimate interest in running our business. Marketing messages are sent only with your consent.",
  },
  {
    title: "Cookies and analytics",
    body: "This site uses essential cookies to function. Analytics cookies (such as Google Analytics) are only loaded if you accept them via the cookie banner. Declining analytics will not affect your use of the site.",
  },
  {
    title: "Who we share it with",
    body: "We do not sell your personal information. It may be processed by trusted service providers (for example website hosting and email services) under appropriate contracts, only as needed to run our business.",
  },
  {
    title: "How long we keep it",
    body: "We keep enquiry details only as long as needed to handle your enquiry and any resulting work, and to meet legal or accounting requirements, after which they are securely deleted.",
  },
  {
    title: "Your rights",
    body: `Under UK GDPR you have the right to access, correct or delete your personal data, to object to or restrict processing, and to data portability. To exercise any of these rights, contact us at ${site.email}. You also have the right to complain to the Information Commissioner's Office (ico.org.uk).`,
  },
  {
    title: "Changes to this policy",
    body: "We may update this policy from time to time. The version on this page is the current one.",
  },
];

export default function Privacy() {
  return (
    <>
      <SEO
        title="Privacy Policy | My Blinds Company"
        description="How My Blinds Company collects, uses and protects your personal information, in line with UK GDPR."
        path="/privacy-policy"
      />
      <section className="bg-warm-50 py-14 sm:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <h1 className="font-serif text-4xl text-slate-900 tracking-tight">Privacy Policy</h1>
            <p className="mt-3 text-sm text-slate-500">Last updated: July 2026</p>
          </Reveal>
          <div className="mt-10 space-y-8">
            {sections.map((s) => (
              <Reveal key={s.title}>
                <section>
                  <h2 className="font-sans text-lg font-semibold text-slate-900 mb-2">{s.title}</h2>
                  <p className="text-sm sm:text-base leading-relaxed text-slate-600">{s.body}</p>
                </section>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
